import Crud from '@/stores/crudBase';
import api from '@/apis/fa/qltsVoucherAPI.js';
var crud = new Crud('qltsVoucher', api);

const state = {
  ...crud.state,
  _config: {
    table: 'qlts_voucher',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Cập nhật bản ghi mới ra màn danh sách sau khi sinh
   * NTLOC 20.09.2022
   */
  async insertFixedAsset(context, payload) {
    context.commit('insertListItem', payload);
  },

  /**
   * Lấy dữ liệu từ Qlts
   * TVDAT 14/09/2022
   */
  async getDataQlts(context, payload) {
    let res = await api.getDataQlts(payload);
    if (res) {
      return res;
    }
  },
  /**
   * Sinh chứng từ khi chọn tài sản từ QLTS
   * TVDAT 07/09/2022
   */
  async generateVoucherQlts(context, payload) {
    let res = await api.generateVoucherQlts(payload);
    if (res) {
      return res;
    }
  },
  /**
   * Lấy dữ liệu map nguồn Qlts
   * TVDAT 09/09/2022
   */
  async mappingBudgetSourceQlts(context, payload) {
    let res = await api.mappingBudgetSourceQlts(payload);
    if (res) {
      return res;
    }
  },
  /**
   * Lấy dữ liệu map nguồn Qlts
   * TVDAT 09/09/2022
   */
  async updateMappingBudgetSourceQlts(context, payload) {
    let res = await api.updateMappingBudgetSourceQlts(payload);
    if (res) {
      return res;
    }
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
